import axios, { AxiosRequestConfig, AxiosResponse } from "axios";

import { getCookie } from "../utils";

const axiosOptions: AxiosRequestConfig = {
  headers: {
    "X-Requested-With": "XMLHttpRequest",
    "X-Source": "enerflo-proposals",
  },
};

const request = axios.create(axiosOptions);

const buildRequestHeaders = (url: string, options: { authenticate?: boolean } = {}) => {
  const result: AxiosRequestConfig["headers"] = {};
  const isDemoAPI = url.includes("proposals/api/demo/");

  // Don't add this header for the demo proposal since that uses it's own internal API routes
  if (!isDemoAPI) {
    result["X-API-Service"] = "Internal";
  }

  if (options.authenticate) {
    result["Authorization"] = `Bearer ${getCookie("enerflo_token")}`;
  }

  return result;
};

export const makeGetRequest = <T = any>(url: string, options: AxiosRequestConfig = {}) => {
  return request.get<T>(url, {
    ...options,
    headers: {
      ...buildRequestHeaders(url, { authenticate: true }),
      ...options.headers,
    },
    withCredentials: true,
  });
};

export const makeUnauthenticatedGetRequest = <T = any>(url: string, options: AxiosRequestConfig = {}) => {
  return request.get<T>(url, {
    ...options,
    headers: {
      ...buildRequestHeaders(url),
      ...options.headers,
    },
  });
};

export const makePostRequest = <T, R = any>(url: string, payload: T, options: AxiosRequestConfig = {}) => {
  return request.post<T, AxiosResponse<R>>(url, payload, {
    ...options,
    headers: {
      ...buildRequestHeaders(url, { authenticate: true }),
      ...options.headers,
    },
    withCredentials: true,
  });
};

export const makePutRequest = <T, R = any>(url: string, payload: T, options: any = {}) => {
  return request.put<T, AxiosResponse<R>>(url, payload, {
    ...options,
    headers: {
      ...buildRequestHeaders(url, { authenticate: true }),
      ...options.headers,
    },
    withCredentials: true,
  });
};

export const makeDeleteRequest = <T, R = any>(url: string, options: any = {}) => {
  return request.delete<T, AxiosResponse<R>>(url, {
    ...options,
    headers: {
      ...buildRequestHeaders(url, { authenticate: true }),
      ...options.headers,
    },
    withCredentials: true,
  });
};
